import React from "react";
import { SDLCMetadataTypeGuards } from "@sscs/types";
import { KeyValueList, Section, ValueOrPlaceholder } from "@sscs/ui";
import { capitalizeFirstLetter } from "@sscs/utils";
import { COMMUNITY_TYPE_TO_TEXT } from "../../../../constants";
import { PolicyAudit } from "../../../common";
import styles from "./softwareIdentitySection.module.scss";
const SCENARIO_TO_TEXT = {
    develop: "Development",
    release: "Release",
};
const transformIdentityValues = ([key, value]) => {
    if (key.toLowerCase() === "purl") {
        return [key.toUpperCase(), value];
    }
    else if (key.toLowerCase() === "community") {
        return [
            capitalizeFirstLetter(key),
            SDLCMetadataTypeGuards.stringIsCommunityType(value)
                ? COMMUNITY_TYPE_TO_TEXT[value]
                : value,
        ];
    }
    else {
        return [capitalizeFirstLetter(key), value];
    }
};
const SoftwareIdentitySection = ({ identity, link, }) => (React.createElement(React.Fragment, null,
    React.createElement(Section, null,
        React.createElement(Section.Title, { as: "h3" }, "Software identity"),
        link ? React.createElement(Section.Action, null, link) : null,
        React.createElement(Section.Content, null, React.createElement(KeyValueList, { list: {
                Product: React.createElement(ValueOrPlaceholder, { value: identity.product }),
                Version: React.createElement(ValueOrPlaceholder, { value: identity.version }),
                Publisher: React.createElement(ValueOrPlaceholder, { value: identity.publisher }),
                PURL: (React.createElement("code", { className: styles.mono },
                    React.createElement(ValueOrPlaceholder, { value: identity.purl }))),
                "Verified by": identity.verified,
                "Verified matches": (React.createElement(ValueOrPlaceholder, { value: identity.matches.length > 0
                        ? identity.matches.join(", ")
                        : null })),
                "Software type": (React.createElement(ValueOrPlaceholder, { value: capitalizeFirstLetter(identity.type) })),
                "Use scenario": (React.createElement(React.Fragment, null,
                    "During ",
                    SCENARIO_TO_TEXT[identity.scenario],
                    identity.install === "optional" &&
                        ` (${capitalizeFirstLetter(identity.install)})`)),
                Category: (React.createElement(ValueOrPlaceholder, { value: capitalizeFirstLetter(identity.category) })),
                Community: COMMUNITY_TYPE_TO_TEXT[identity.community],
                License: React.createElement(ValueOrPlaceholder, { value: identity.license }),
                Description: React.createElement(ValueOrPlaceholder, { value: identity.description }),
                CPE: (React.createElement("code", { className: styles.mono },
                    React.createElement(ValueOrPlaceholder, { value: identity.cpe }))),
            } }))),
    identity.edit.present ? (React.createElement(Section, null,
        React.createElement(Section.Title, { as: "h3" }, "Software identity edit record"),
        React.createElement(Section.Content, null,
            React.createElement(PolicyAudit, { audit: identity.edit, title: "Audit", nested: true }),
            React.createElement(Section, null,
                React.createElement(Section.Title, { as: "h4" }, "Original identity"),
                React.createElement(Section.Content, null, identity.original.length > 0 ? (React.createElement(KeyValueList, { list: Object.fromEntries(identity.original
                        .map(transformIdentityValues)
                        .map(([key, value]) => [
                        key,
                        key === "PURL" ? (React.createElement("code", { key: key, className: styles.mono },
                            React.createElement(ValueOrPlaceholder, { value: value }))) : (React.createElement(ValueOrPlaceholder, { key: key, value: value })),
                    ])) })) : ("The component did not have identity information before the edit")))))) : null));
export default SoftwareIdentitySection;
//# sourceMappingURL=SoftwareIdentitySection.js.map